import { APIClient } from '../api/useAPIClient';
import { SinapseAction } from './constants/actions';

// region Async AI Response
export type AsyncSinapseResponseID = string;
export type AsyncSinapseAction = SinapseAction;
export type languageOption = 'pt' | 'en' | 'es';
export type AsyncSinapseResponse = {
  task_id: AsyncSinapseResponseID;
  error?: unknown;
};
export type SinapseInput = {
  input: unknown;
  language?: languageOption;
  source?: number;
  api: APIClient;
  prefix_url?: string;
  endpoint?: string;
  action: AsyncSinapseAction;
};

export type SinapseInputText = SinapseInput & { input: string };
export type SinapseResult = { text: string; competencies?: number[] } | undefined;

interface SinapseScreeningQuestion {
  question: string;
  options: string[];
}

export type SinapseScreeningQuestionsResult =
  | {
      text: null;
      questions: SinapseScreeningQuestion[];
    }
  | {
      text: string;
      questions: null;
    };

export type SinapsePracticalTechnicalCaseResult =
  | { err: string }
  | { candidate_instructions: string; recruiter_instructions: string };

export type AsyncSinapseResponseStatus<R = SinapseResult> = {
  task_id: AsyncSinapseResponseID;
  status: 'pending' | 'completed' | 'failed';
  result: R;
  error_message?: string;
};

export const sendAsyncTextToProcess = async ({
  input,
  language = 'pt',
  prefix_url = '',
  action,
  endpoint = 'async_process_text/',
  source,
  api,
}: SinapseInputText): Promise<AsyncSinapseResponse> => {
  const response = await api.post<{ task_id: string }>(`${prefix_url}${endpoint}`, {
    input,
    language,
    source,
    action,
  });
  return { task_id: response.data.task_id, error: undefined };
};
export const getSynapseResponseStatus = async <R = SinapseResult>({
  task_id,
  api,
  prefix_url = '',
  endpoint = 'sinapse_response_status/',
}: {
  task_id: AsyncSinapseResponseID;
  api: APIClient;
  prefix_url?: string;
  endpoint?: string;
}): Promise<AsyncSinapseResponseStatus<R>> => {
  const response = await api.get<AsyncSinapseResponseStatus>(`${prefix_url}${endpoint}`, {
    params: { task_id },
  });
  return response.data;
}; // endregion
